<div class="p-4 space-y-5">

  <h2 class="text-xl font-semibold text-gray-700">
    All Issued Stock List
  </h2>

  <!-- FILTER BAR -->
  <div class="bg-white border border-yellow-200 p-3 rounded-lg shadow-sm flex flex-col md:flex-row gap-3 items-center">

    <input
      type="text"
      placeholder="Search..."
      [(ngModel)]="searchText"
      class="w-full md:w-1/3 px-3 py-2 rounded-md border border-blue-200 bg-blue-50/30 text-gray-700
             focus:outline-none focus:ring-1 focus:ring-blue-300 transition" />

    <select
      [(ngModel)]="filterStaffName"
      class="px-3 py-2 rounded-md border border-blue-200 bg-blue-50/30 text-gray-700
             focus:outline-none focus:ring-1 focus:ring-blue-300 transition">
      <option value="">All Staff</option>
      <option *ngFor="let s of issuedList" [value]="s.issued_to_name">
        {{ s.issued_to_name }}
      </option>
    </select>

    <select
      [(ngModel)]="filterCategory"
      class="px-3 py-2 rounded-md border border-blue-200 bg-blue-50/30 text-gray-700
             focus:outline-none focus:ring-1 focus:ring-blue-300 transition">
      <option value="">All Categories</option>
      <option *ngFor="let c of issuedList" [value]="c.std_item_category">
        {{ c.std_item_category }}
      </option>
    </select>

  </div>

  <!-- LIGHT YELLOW OUTLINE TABLE -->
  <div class="overflow-x-auto bg-white border border-yellow-200 rounded-xl shadow-sm">
    <table class="w-full table-auto text-sm text-gray-800">

      <!-- HEADER (Light Blue) -->
      <thead class="bg-blue-50 text-gray-700">
        <tr>
          <th class="p-3 border border-yellow-100">No</th>
          <th class="p-3 border border-yellow-100">Barcode</th>
          <th class="p-3 border border-yellow-100">Parent Code</th>
          <th class="p-3 border border-yellow-100">Product</th>
          <th class="p-3 border border-yellow-100">Category</th>
          <th class="p-3 border border-yellow-100">Weight</th>
          <th class="p-3 border border-yellow-100">Staff ID</th>
          <th class="p-3 border border-yellow-100">Issued To</th>
          <th class="p-3 border border-yellow-100">Status</th>
        </tr>
      </thead>

      <!-- BODY -->
      <tbody>

        <tr
          *ngFor="let item of paginatedItems(); let i = index"
          class="odd:bg-white even:bg-blue-50/20 hover:bg-yellow-50 transition">
          
          <td class="p-3 border border-blue-100">{{ (currentPage - 1) * pageSize + i + 1 }}</td>

          <td class="p-3 border border-blue-100 font-medium text-gray-800">
            {{ item.std_barcode }}
          </td>

          <td class="p-3 border border-blue-100">
            {{ item.std_item_code }}
          </td>

          <td class="p-3 border border-blue-100 font-medium">
            {{ item.std_item_name }}
          </td>

          <td class="p-3 border border-blue-100">
            {{ item.std_item_category }}
          </td>

          <td class="p-3 border border-blue-100">
            {{ item.std_net_weight }}
          </td>

          <td class="p-3 border border-blue-100 text-green-700 font-semibold">
            {{ item.issued_stock_id }}
          </td>

          <td class="p-3 border border-blue-100 text-blue-700 font-medium">
            {{ item.issued_to_name }}
          </td>

          <td class="p-3 border border-blue-100">
            <span class="px-3 py-1 rounded-full bg-yellow-100 text-yellow-800 text-xs border border-yellow-300">
              Active
            </span>
          </td>

        </tr>

        <tr *ngIf="paginatedItems().length === 0">
          <td colspan="9" class="text-center p-4 text-gray-500">
            No matching results.
          </td>
        </tr>

      </tbody>
    </table>
  </div>

  <!-- PAGINATION -->
  <div class="flex justify-center items-center gap-3 mt-3">

    <button
      (click)="prevPage()"
      [disabled]="currentPage === 1"
      class="px-3 py-1 border rounded-md bg-blue-50 text-blue-700 disabled:opacity-40 transition">
      ← Prev
    </button>

    <span class="text-gray-700 text-sm">
      Page {{ currentPage }} of {{ totalPages }}
    </span>

    <button
      (click)="nextPage()"
      [disabled]="currentPage === totalPages"
      class="px-3 py-1 border rounded-md bg-blue-50 text-blue-700 disabled:opacity-40 transition">
      Next →
    </button>

  </div>

</div>
